export default "__VITE_ASSET__BZYPOk0i__"